<template>
  <div>
    <el-input placeholder="Поиск по всем разделам" v-model="searchQuery" class="input-with-select">
      <el-button slot="append" icon="el-icon-search"></el-button>
    </el-input>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    name: 'DepositorySearch',
    computed: {
      ...mapGetters('depository', [
        'getSearchQuery'
      ]),
      searchQuery: {
        get: function () {
          return this.getSearchQuery
        },
        set: function (val) {
          this.setSearchQuery(val)
        }
      }
    },
    methods: {
      ...mapActions('depository', [
        'setSearchQuery'
      ])
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/DepositorySearch.vue